@if (loading$ | async) {
    <frog-async-spinner></frog-async-spinner>
}

@if (assets$ | async; as assets) {
    <div>
        @if (assets.length > 0) {
            @if (preferences$ | async; as preferences) {
                <div
                    class="grid"
                    [style.grid-gap.px]="preferences.thumbnail_padding"
                    [class.large]="preferences.use_large_thumbnails"
                >
                    @for (asset of assets; track asset) {
                        <frog-asset-thumbnail [asset]="asset"></frog-asset-thumbnail>
                    }
                </div>
            }
        } @else {
            @if (preferences$ | async; as preferences) {
                <div class="flex column align-center justify-center">
                    <img src="assets/Images-amico.png" class="empty" />
                    <h1>There doesn't seem to be anything here</h1>
                    <p>Drag in files or use the Upload button</p>
                </div>
            }
        }
    </div>
}
<ng-template #empty>
    @if (preferences$ | async; as preferences) {
        <div class="flex column align-center justify-center">
            <img src="assets/Images-amico.png" class="empty" />
            <h1>There doesn't seem to be anything here</h1>
            <p>Drag in files or use the Upload button</p>
        </div>
    }
</ng-template>
